// Angular Imports
import { NgModule } from "@angular/core";

// Bibliotecas Terceiras
import { TextMaskModule } from "angular2-text-mask";

// Componentes
import { AdministrativoClientesComponent } from "./administrativo-clientes.component";
import { AdministrativoClientesRoutingModule } from "./administrativo-clientes.routing";
import { SharedModule } from "@app/shared/shared.module";
import { AdministrativoClientesFormularioComponent } from "./form-clientes/administrativo-clientes-formulario.component";
import { AdministrativoClientesListaComponent } from "./lista-clientes/administrativo-clientes-lista.component";
import { AdministrativoClientesLayoutComponent } from "./administrativo-clientes-layout/administrativo-clientes-layout.component";

@NgModule({
  declarations: [
    AdministrativoClientesComponent,
    AdministrativoClientesLayoutComponent,
    AdministrativoClientesListaComponent,
    AdministrativoClientesFormularioComponent
  ],
  imports: [
    AdministrativoClientesRoutingModule,
    SharedModule,
    TextMaskModule
  ],
  providers: [
  ]
})
export class AdministrativoClientesModule { }
